/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';

import * as AppPropTypes from '../../../lib/PropTypes';

import FooterDefault from '../../partials/FooterDefault';

import styles from '../../../../styles/themes/iga/footer-iga-habs.module.scss';

import IgaCHFooter from '../../../../img/iga/iga-ch-footer-logo.png';

const propTypes = {
    page: AppPropTypes.page,
};

const defaultProps = {
    page: null,
};

function FooterIgaHabs({ page, ...props }) {
    const { handle = null } = page || {};
    const isHome = handle === 'home';
    return (
        <div className={styles.container}>
            {isHome ? (
                <>
                    <div className={styles.logoContainer}>
                        <div className={styles.fakeBottom} />
                        <img className={styles.logo} src={IgaCHFooter} alt="IGA-CH" />
                    </div>
                </>
            ) : null}
            <FooterDefault
                {...props}
                className={classNames([styles.defaultFooter, { [styles.withoutGap]: isHome }])}
            />
        </div>
    );
}

FooterIgaHabs.propTypes = propTypes;
FooterIgaHabs.defaultProps = defaultProps;

export default FooterIgaHabs;
